import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["t"],
  _excluded2 = ["t"],
  _excluded3 = ["t"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { showToast } from 'hoi-poi-ui';
const defaultCrudToastProps = {
  position: 'bottomLeft',
  transition: 'slide',
  useDefaultCloseButton: true
};
export const successToast = _ref => {
  let {
      t
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!t && !props.title) return;
  showToast(_objectSpread(_objectSpread({}, defaultCrudToastProps), {}, {
    type: 'success',
    title: t('cfm_label_success')
  }, props));
};
export const errorToast = _ref2 => {
  let {
      t
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  if (!t && !props.title) return;
  showToast(_objectSpread(_objectSpread({}, defaultCrudToastProps), {}, {
    type: 'error',
    title: t('error_generalerror')
  }, props));
};
export const infoToast = _ref3 => {
  let {
      t
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  if (!t) return;
  showToast(_objectSpread(_objectSpread({}, defaultCrudToastProps), {}, {
    type: 'info'
  }, props));
};